import { capInventorySourceRows } from './computed-persistence';
import type { CreatureJumpOverrideInput, CreatureJumpOverrideResult, CreatureSpeedSource } from '../types';

/** Select the zero-walk or authored-jump branch; return `derived` when formula work remains. */
export function compileCreatureJumpOverride(input: CreatureJumpOverrideInput): CreatureJumpOverrideResult {
    if (input.walk === null || input.walk === 0) {
        return {
            handled: true,
            branch: 'zero-walk',
            persisted: input.authoredJumpBase > 0 ? { total: 0, base: 0, locked: true } : null,
        };
    }
    if (input.explicitJump === null || input.explicitJump <= 0) {
        return { handled: false, branch: 'derived', persisted: null };
    }

    const baseSources: CreatureSpeedSource[] = input.baseSources.map(source => ({ ...source }));
    const [capped] = capInventorySourceRows(input.dynamicSources);
    const dynamicSources = Object.values(capped) as unknown as CreatureSpeedSource[];
    const sources = [...baseSources, ...dynamicSources];
    const categoryTotals = new Map<string, number>();
    for (const source of sources) {
        const category = typeof source.category === 'string' ? source.category : source.kind;
        categoryTotals.set(category, (categoryTotals.get(category) ?? 0) + source.value);
    }
    const breakdown = Object.fromEntries(categoryTotals);
    return {
        handled: true,
        branch: 'authored',
        persisted: {
            total: Math.trunc(input.explicitJump),
            base: 0,
            locked: input.dynamicBrace !== null,
            ...(sources.length ? { sources } : {}),
            ...(Object.keys(breakdown).length ? { breakdown } : {}),
        },
    };
}
